export default __webpack_public_path__ + "static/media/landing-img2.1390405f.png";